"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_TYPE = void 0;
exports.USER_TYPE = {
    CUSTOMER: 'CUSTOMER',
    INTERNAL_USER: 'INTERNAL_USER',
    SYSTEM: 'SYSTEM'
};
//# sourceMappingURL=userType.js.map